import { API_ENDPOINTS } from "./apiEndpoints";
export const LIVE_API_BASE = "https://vendorsync.dtlamarketing.com";
export const API_BASE = (() => {
  if (process.env.REACT_APP_API_BASE) {
    return process.env.REACT_APP_API_BASE;
  }
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (
      host === "localhost" ||
      host === "127.0.0.1" ||
      host.endsWith(".ngrok-free.dev") ||
      host.endsWith(".ngrok-free.app") ||
      host.endsWith(".ngrok.io") ||
      host.endsWith(".ngrok.app") ||
      host.startsWith("192.168.") ||
      host.startsWith("10.")
    ) {
      return "http://localhost:8000";
    }
  }
  return LIVE_API_BASE;
})();

export function getToken() {
  return localStorage.getItem("token");
}

export function saveToken(token) {
  localStorage.setItem("token", token);
}

export function clearToken() {
  localStorage.removeItem("token");
}

export async function authenticatedFetch(endpoint, options = {}) {
  const token = getToken();
  const headers = {
    "ngrok-skip-browser-warning": "true",
    ...(options.headers || {}),
  };
  
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    clearToken();
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event("unauthorized"));
    }
    // Return pending promise to prevent caller catch block from triggering alert popups
    return new Promise(() => {});
  }

  return response;
}

export async function loginUser(username, password) {
  const response = await fetch(`${API_BASE}${API_ENDPOINTS.login}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "ngrok-skip-browser-warning": "true",
    },
    body: new URLSearchParams({ username, password }),
  });
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || "Login failed");
  }
  
  const data = await response.json();
  saveToken(data.access_token);
  return data;
}

export async function registerUser(username, password, email) {
  const response = await fetch(`${API_BASE}${API_ENDPOINTS.register}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
    body: JSON.stringify({ username, password, email: email || null }),
  });
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || "Registration failed");
  }
  
  return response.json();
}

export async function checkAuth() {
  const token = getToken();
  if (!token) return false;
  try {
    const res = await fetch(`${API_BASE}${API_ENDPOINTS.me}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    });
    return res.ok;
  } catch {
    return false;
  }
}
